<template>
  <div class="user">
    <div class="userBox">
      <el-row>
        <el-col :span="22">编辑用户</el-col>
        <el-col :span="2">
          <el-button
            type="info"
            round
            icon="el-icon-back"
            size="small"
            @click="goBack()"
          >
            返 回
          </el-button>
        </el-col>
      </el-row>

      <div class="formBox">
        <el-form
          :model="userDetail"
          ref="ruleForm"
          label-width="100px"
        >

          <el-form-item label="用户名称">
            {{ userDetail.name }}
          </el-form-item>

          <el-form-item label="手机号">
            {{ userDetail.cellphone }}
          </el-form-item>

          <el-form-item label="区域">
            {{ userDetail.regionName }}
          </el-form-item>

          <el-form-item label="客户">
            {{ userDetail.resellerName }}
          </el-form-item>

          <el-form-item label="二级客户" prop="secondReseller" v-if="userDetail.roleCode === '客户总部'">
            <el-select
              v-model="userDetail.secondReseller"
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in subResellerList"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="角色" prop="role">
            <el-select
              v-model="userDetail.roleCode"
              clearable
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in roleList"
                :key="item.no"
                :label="item.name"
                :value="item.no"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>

      <!--<el-row style="margin: 40px 0 30px">
        <el-col :span="22">
        </el-col>
        <el-col :span="12">
          <div>OPR系统内权限</div>
          <el-checkbox-group v-model="authority" class="checkboxBox">
            <el-checkbox label="1" name="authority">编辑题目</el-checkbox>
            <el-checkbox label="2" name="authority">VMS检查</el-checkbox>
            <el-checkbox label="3" name="authority">编辑问卷</el-checkbox>
            <el-checkbox label="4" name="authority">Operation检查</el-checkbox>
            <el-checkbox label="5" name="authority">编辑用户角色权限</el-checkbox>
            <el-checkbox label="6" name="authority">Training检查</el-checkbox>
            <el-checkbox label="7" name="authority">查看统计报表</el-checkbox>
            <el-checkbox label="8" name="authority">系统配置</el-checkbox>
          </el-checkbox-group>
        </el-col>
      </el-row>-->

      <footer>
        <el-button type="success" @click="save()">
          保 存
        </el-button>
      </footer>
    </div>
  </div>
</template>
<script>
import md5 from "md5";
import _ from "lodash";

export default {
  name: "UserEdit",
  data() {
    return {
      id: this.$route.query.id || null,
      roleList: [],
      subResellerList: [],
      userDetail: {
      },
      // authority: []
    }
  },
  mounted() {
    this.getOptions()
    // todo: 如果有查询id,则根据id去获取数据
    if (this.id) {
      this.getData()
    }
  },
  computed: {
  },
  methods: {
    async getOptions() {
      let res = await axios.post(vmsReqUrl+"account/queryConditions", _.omit(this.filterData, ['searchTerm']));
      if (res.data.code === 200) {
        const dataList = res.data.data;
        this.roleList = dataList.role;
        // console.log('this.roleList', this.roleList)
        this.subResellerList = dataList.secondReseller
      }
    },
    async getData() {
      let res = await axios.post(vmsReqUrl+"account/getAccountDetail/" + this.id);
      if (res.data.code === 200) {
        const accountDetail = res.data.data.account
        this.userDetail = accountDetail
        // this.roleList = res.data.data.roleList
      }
    },
    goBack() {
      this.$router.push({ path: '/vms/userManage' });
    },
    async save() {
      const roleCode = this.userDetail.roleCode;
      let secondReseller = ''
      if (roleCode === '客户总部') {
        secondReseller = this.userDetail.secondReseller;
      }
      let res = await axios.put("account?id=" + this.id + "&roleCode=" + roleCode + "&secondReseller=" + secondReseller);
      if (res.data.code === 200) {
        this.$message.success("保存成功");
        this.$router.push({ path: '/vms/userManage' });
      }
    }
  }
};
</script>
<style lang="sass" scoped>
.user
  min-width: 1050px
  .userBox
    padding: 20px
    .formBox
      width: 60%
      margin-left: 20%
      margin-top: 20px
    h5
      margin: 0
      font-size: 14px
    .checkboxBox
      label
        display: block
        float: left
        width: 40%
        padding: 30px 0 0
        font-weight: 400
    footer
      padding-top: 30px
      text-align: center

</style>



// WEBPACK FOOTER //
// src/vms/pages/views/userEdit.vue